import React, { useEffect, useState } from "react";
import "./Search_Result_Page.css";
import Top_Filter_Div from "../categories/top_filter_div/Top_Filter_Div";
import Common_Title from "../common_components/common_title/Common_Title";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Common_Product_Card from "../common_components/common_product_card/Common_Product_Card";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { variant_type } from "../../utils/common";
import { HighLowPrice } from "../../features/master/masterSlice";

const Search_Result_Page = () => {
  const breadcrumbs2 = [
    { label: "Home", link: "/", isActive: false },
    { label: "SEARCH", link: "", isActive: true },
  ];

  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState(null);

  const location = useLocation();
  const [subCategoryId, setSubCategoryId] = useState(null);

  const { id } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const [searchTerm, setSearchTerm] = useState(searchValue || "");
  const allProducts = useSelector((state) => state.product.allProducts);

  const highlowprice = useSelector((state) => state.master.high_low_price);
  const [activeSize, setActiveSize] = useState([]);
  const [activeMattress, setActiveMattress] = useState([]);
  const [activeHeight, setActiveHeight] = useState([]);

  const [discount, setDiscount] = useState();
  useEffect(() => {
    dispatch(HighLowPrice());
  }, [dispatch]);
  const [priceRange, setPriceRange] = useState([0, 0]);

  useEffect(() => {
    if (highlowprice) {
      setPriceRange([
        Number(highlowprice?.lowest_price) || 0,
        Number(highlowprice?.highest_price) || 0,
      ]);
    }
  }, [highlowprice]);
  useEffect(() => {
    setSubCategoryId(id);
    dispatch(
      getAllProducts({
        name: searchTerm,
        height_id: activeHeight || "",
        size_id: activeSize || "",
        mattress_id: activeMattress || "",
        priceOrder: priceRange || "",
        sortBy: selectedOption || "",
        // page: currentPage || 1,
        discount: discount || "",
        per_page: 10,
      }),
    );
  }, [
    dispatch,
    searchTerm,
    priceRange,
    selectedOption,
    activeSize,
    activeHeight,
    activeMattress,
    discount,
    selectedOption,
    // currentPage,
  ]);

  return (
    <section className="Search_Result_Page">
      <Top_Filter_Div
        subTitle={"SEARCH"}
        breadcrumbs2={breadcrumbs2}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        setDiscount={setDiscount}
        discount={discount}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        setActiveMattress={setActiveMattress}
        activeMattress={activeMattress}
        activeSize={activeSize}
        setActiveSize={setActiveSize}
        setActiveHeight={setActiveHeight}
        activeHeight={activeHeight}
      />
      <div className="search_main_div">
        <div className="container">
          <div className="search_div">
            <Common_Title title={"SEARCH RESULTS"} />

            <div className="right_side_div">
              <div className="input_holder">
                <Form.Control
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <div className="search_icon_div">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="search_icon"
                  />
                </div>
              </div>

              <p className="label_text">{allProducts?.total || 0} Results</p>
            </div>
          </div>

          <div className="all_cards_div">
            <div className="row">
              {allProducts?.data?.length > 0 ? (
                allProducts?.data?.map((product) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      key={product?.id}
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-5 custom_col"
                    >
                      <Common_Product_Card
                        product={product}
                        id={product.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                        productName={product.name}
                        sellingPrice={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={metal?.Metal?.name}
                        discount={
                          activeVariant?.mrp
                            ? (
                                ((parseFloat(activeVariant?.mrp || 0) -
                                  parseFloat(activeVariant?.price || 0)) /
                                  parseFloat(activeVariant?.mrp || 1)) *
                                100
                              ).toFixed(0)
                            : 0
                        }
                         feature={product?.Product_Fetures}
                        btnText={"Shop Now"}
                      />
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Search_Result_Page;
